module.exports = __webpack_public_path__ + "static/media/12UNCTAD17.0a0585f7.jpg";